"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountedUpsellMessage = exports.AutoRenewMessage = exports.AutoRenewMessageWrapper = exports.PaymentMethodsWidgetContainer = exports.Checkbox = exports.ButtonContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const themed_text_1 = require("../themed-text");
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  text-align: left;
`;
exports.ButtonContainer = styled_components_1.default.div `
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 24px 16px;
  ${({ sticky, deviceType, platformType }) => sticky &&
    `
    background: white;
    position: fixed;
    bottom: 0;
    box-shadow: 0px -6px 6px -6px #00000080;
    ${deviceType === monera_app_core_1.DeviceType.MShop && platformType === monera_app_core_1.PlatformType.Ios ? 'padding-bottom: 105px;' : ''}
  `}
`;
exports.Checkbox = styled_components_1.default.input.attrs({ type: 'checkbox' }) `
  margin-right: 10px;
  cursor: pointer;
  scale: 1.5;

  &:checked {
    accent-color: ${monera_app_core_1.Blue_400};
    font-weight: bold;
  }
`;
exports.PaymentMethodsWidgetContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  width: 100%;
`;
exports.AutoRenewMessageWrapper = styled_components_1.default.div `
  width: 100%;
`;
exports.AutoRenewMessage = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  width: 100%;
`;
exports.DiscountedUpsellMessage = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  width: 100%;
`;
